import type { AxiosResponse } from 'axios';
import { redirect } from 'react-router';

import Auth from '../api/auth';
import Provision from '../api/provision';
import rbacCheck from '../rbac/rbacCheck';
import { store, type RootState } from '../redux/store';

import createLoader from './createLoader';

export const organizationLoader = createLoader(
  Auth.fetchV1OrganizationById as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['organizationId']
);
export const projectLoader = createLoader(
  Auth.fetchV2ProjectById as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['projectId']
);
export const productLoader = createLoader(
  Auth.fetchV2ProductById as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['productId']
);
export const userLoader = createLoader(
  Auth.fetchV2UserByUuid as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['uuid']
);
export const contactLoader = createLoader(Provision.fetchContacts, ['contactId:_id']);
export const osProjectLoader = createLoader(
  Provision.fetchOsProjectDetails as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['juiceGroup', 'cloudId', 'osprojectName']
);
export const caasClusterLoader = createLoader(
  Provision.fetchClusterDetailsV1 as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['clusterName']
);
export const createProtectedRouteLoader = (
  permission: string,
  getData: ((state: ReturnType<typeof store.getState>) => unknown) | null = null
): (() => void) => {
  return () => {
    const state = store.getState() as RootState;
    const userData = state.user;
    const userRoles = userData.roles;

    if (!userRoles || userRoles.length === 0) {
      // redirect() returns a Response, not an Error — React Router's data APIs expect it thrown as-is.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect('/404');
    }

    const checkData = getData ? getData(state) : state.user.organization;
    const hasPermission = rbacCheck(userRoles, permission, checkData);

    if (!hasPermission) {
      // redirect() returns a Response, not an Error — React Router's data APIs expect it thrown as-is.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect('/404');
    }
  };
};
